import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    CheckCircle2,
    ArrowRight,
    Play
} from 'lucide-react';
import './Solutions.css';
import '../LandingPage.css'; // For shared dropdown nav styles

// Import the specific tracking images
import mapImg from '../../../assets/map_image.png';
import mobileImg from '../../../assets/mobile.png';
import tmsLogo from '../../../assets/TmsLogoh.png';

const SuiviTempsReel = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="saas-container">
            {/* Minimalist SaaS Navbar */}
            <nav className="landing-nav saas-nav">
                <div className="nav-container">
                    <div className="nav-logo">
                        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none' }}>
                            <img src={tmsLogo} alt="Bfret Logo" style={{ height: '32px' }} />
                        </Link>
                    </div>
                    <div className="nav-links">
                        <div className="nav-dropdown">
                            <span className="nav-dropdown-toggle">Solutions</span>
                            <div className="nav-dropdown-menu">
                                <Link to="/solutions/planification-intelligente">Planification intelligente</Link>
                                <Link to="/solutions/suivi-temps-reel">Suivi en temps réel</Link>
                                <Link to="/solutions/documents-centralises">Documents centralisés</Link>
                                <Link to="/solutions/rapports-analytics">Rapports & Analytics</Link>
                                <Link to="/solutions/gestion-ressources">Gestion des ressources</Link>
                                <Link to="/solutions/ai-agent-center">AI Agent Center</Link>
                            </div>
                        </div>
                        <Link to="/contact" className="btn-primary saas-btn-primary" style={{ marginLeft: '1rem' }}>Démo</Link>
                    </div>
                </div>
            </nav>

            {/* Full Hero Introduction */}
            <section style={{ padding: '6rem 5% 4rem', textAlign: 'center', backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                <span className="saas-feature-tag" style={{ display: 'inline-block', marginBottom: '1.5rem', backgroundColor: '#e0e7ff', color: '#4338ca', padding: '0.5rem 1rem', borderRadius: '9999px', fontWeight: '600' }}>Visibilité & Exécution</span>
                <h1 style={{ fontSize: '3.5rem', maxWidth: '1000px', margin: '0 auto 1.5rem', color: '#0f172a', lineHeight: '1.1' }}>
                    Suivez vos véhicules et chauffeurs en temps réel
                </h1>
                <p style={{ fontSize: '1.25rem', maxWidth: '750px', margin: '0 auto 2.5rem', color: '#475569', lineHeight: '1.6' }}>
                    Ne vous demandez plus où en sont vos livraisons. Gardez un œil sur votre flotte grâce à une cartographie en direct et une application chauffeur fluide pour remonter les statuts du terrain instantanément.
                </p>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                    <Link to="/contact" className="saas-btn saas-btn-primary" style={{ padding: '0.875rem 2.5rem', fontSize: '1.1rem', borderRadius: '8px' }}>
                        Demander une démo
                    </Link>
                    <a href="#fonctionnalites" className="saas-btn saas-btn-outline" style={{ padding: '0.875rem 2.5rem', fontSize: '1.1rem', borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <Play size={18} /> Voir la carte
                    </a>
                </div>
            </section>

            {/* Quick Benefits Grid */}
            <section style={{ padding: '4rem 5%', backgroundColor: '#ffffff' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
                    <div style={{ padding: '2rem', backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                        <h3 style={{ fontSize: '1.25rem', color: '#0f172a', marginBottom: '1rem' }}>Localisation en direct</h3>
                        <p style={{ color: '#475569', margin: 0, lineHeight: '1.5' }}>Sachez toujours où se trouve chaque véhicule pour répondre avec précision aux questions de vos clients.</p>
                    </div>
                    <div style={{ padding: '2rem', backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                        <h3 style={{ fontSize: '1.25rem', color: '#0f172a', marginBottom: '1rem' }}>Réactivité face aux aléas</h3>
                        <p style={{ color: '#475569', margin: 0, lineHeight: '1.5' }}>En cas de retard ou d'incident signalé par le chauffeur, ajustez immédiatement la suite de la tournée.</p>
                    </div>
                    <div style={{ padding: '2rem', backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                        <h3 style={{ fontSize: '1.25rem', color: '#0f172a', marginBottom: '1rem' }}>Moins d'appels téléphoniques</h3>
                        <p style={{ color: '#475569', margin: 0, lineHeight: '1.5' }}>Les statuts remontent automatiquement sans avoir besoin d'appeler les conducteurs toutes les heures.</p>
                    </div>
                </div>
            </section>

            {/* SECTION 1: The Map */}
            <section id="fonctionnalites" className="saas-feature-section" style={{ paddingTop: '5rem', paddingBottom: '4rem', borderTop: '1px solid #f1f5f9' }}>
                <div className="saas-feature-grid">
                    <div className="saas-feature-text" style={{ paddingRight: '2rem' }}>
                        <span className="saas-feature-tag">Cartographie</span>
                        <h2 style={{ fontSize: '2.5rem', lineHeight: '1.2', marginBottom: '1.5rem', color: '#0f172a' }}>
                            Visualisez votre flotte sur le terrain
                        </h2>
                        <p style={{ fontSize: '1.15rem', color: '#475569', marginBottom: '2.5rem', lineHeight: '1.6' }}>
                            La carte intégrée vous donne une vue d'ensemble immédiate de la position de tous vos véhicules en mission. Fini le suivi à l'aveugle, l'exploitation garde le contrôle total.
                        </p>
                        
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                            <div>
                                <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#0f172a', marginBottom: '0.5rem' }}>
                                    <CheckCircle2 size={24} color="var(--saas-primary)" />
                                    Positions actualisées
                                </h3>
                                <p style={{ fontSize: '1.05rem', color: '#475569', margin: 0, paddingLeft: '2.25rem' }}>
                                    La carte affiche la dernière position connue de chaque ressource connectée pour un suivi fiable.
                                </p>
                            </div>
                            <div>
                                <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#0f172a', marginBottom: '0.5rem' }}>
                                    <CheckCircle2 size={24} color="var(--saas-primary)" />
                                    Suivi des itinéraires
                                </h3>
                                <p style={{ fontSize: '1.05rem', color: '#475569', margin: 0, paddingLeft: '2.25rem' }}>
                                    Visualisez le tracé de la mission en cours et vérifiez la cohérence des trajets empruntés.
                                </p>
                            </div>
                            <div>
                                <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#0f172a', marginBottom: '0.5rem' }}>
                                    <CheckCircle2 size={24} color="var(--saas-primary)" />
                                    Information client rapide
                                </h3>
                                <p style={{ fontSize: '1.05rem', color: '#475569', margin: 0, paddingLeft: '2.25rem' }}>
                                    Renseignez immédiatement vos clients sur la position de leur marchandise d'un simple coup d'œil sur la carte.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="saas-feature-visual" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ position: 'relative' }}>
                            <div style={{ position: 'absolute', inset: '-10px', background: 'linear-gradient(to right, #e0e7ff, #f3e8ff)', filter: 'blur(30px)', opacity: '0.5', borderRadius: '20px', zIndex: 0 }}></div>
                            <img 
                                src={mapImg} 
                                alt="Carte de suivi des véhicules BFRET" 
                                style={{ 
                                    position: 'relative',
                                    zIndex: 1,
                                    width: '100%', 
                                    maxWidth: '700px',
                                    borderRadius: '12px', 
                                    boxShadow: '0 20px 40px -10px rgba(0, 0, 0, 0.15)',
                                    border: '1px solid rgba(0,0,0,0.05)'
                                }} 
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* SECTION 2: The Driver App (Reversed layout) */}
            <section className="saas-feature-section alt-bg" style={{ paddingTop: '5rem', paddingBottom: '5rem', backgroundColor: '#f8fafc' }}>
                <div className="saas-feature-grid reverse">
                    <div className="saas-feature-text" style={{ paddingLeft: '2rem' }}>
                        <span className="saas-feature-tag">L'Application Chauffeur</span>
                        <h2 style={{ fontSize: '2.5rem', lineHeight: '1.2', marginBottom: '1.5rem', color: '#0f172a' }}>
                            Connectez vos chauffeurs à l'exploitation
                        </h2>
                        <p style={{ fontSize: '1.15rem', color: '#475569', marginBottom: '2.5rem', lineHeight: '1.6' }}>
                            La donnée de terrain remonte sans effort grâce à une application mobile simple et intuitive, pensée pour le quotidien de vos conducteurs.
                        </p>
                        
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                            <div>
                                <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#0f172a', marginBottom: '0.5rem' }}>
                                    <CheckCircle2 size={24} color="var(--saas-primary)" />
                                    Remontée de statuts
                                </h3>
                                <p style={{ fontSize: '1.05rem', color: '#475569', margin: 0, paddingLeft: '2.25rem' }}>
                                    Arrivé sur site, en cours de chargement, terminé... Le chauffeur met à jour le statut en un tap, visible côté planning.
                                </p>
                            </div>
                            <div>
                                <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#0f172a', marginBottom: '0.5rem' }}>
                                    <CheckCircle2 size={24} color="var(--saas-primary)" />
                                    Détails de la mission
                                </h3>
                                <p style={{ fontSize: '1.05rem', color: '#475569', margin: 0, paddingLeft: '2.25rem' }}>
                                    Le conducteur dispose de toutes les informations nécessaires (adresses, références, consignes) directement dans sa poche.
                                </p>
                            </div>
                            <div>
                                <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#0f172a', marginBottom: '0.5rem' }}>
                                    <CheckCircle2 size={24} color="var(--saas-primary)" />
                                    Remontée de documents
                                </h3>
                                <p style={{ fontSize: '1.05rem', color: '#475569', margin: 0, paddingLeft: '2.25rem' }}>
                                    La possibilité de prendre en photo la lettre de voiture (e-CMR) pour la transmettre au bureau sans attendre le retour au dépôt.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="saas-feature-visual" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ position: 'relative' }}>
                            <div style={{ position: 'absolute', inset: '-10px', background: 'linear-gradient(to left, #e0e7ff, #f3e8ff)', filter: 'blur(30px)', opacity: '0.5', borderRadius: '20px', zIndex: 0 }}></div>
                            <img 
                                src={mobileImg} 
                                alt="Application mobile chauffeur BFRET" 
                                style={{ 
                                    position: 'relative',
                                    zIndex: 1,
                                    width: '100%', 
                                    maxWidth: '350px', // Mobile phone frame size usually thinner
                                    borderRadius: '12px', 
                                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.2)'
                                }} 
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Metrics Banner */}
            <section style={{ backgroundColor: '#0f172a', color: 'white', padding: '5rem 5%' }}>
                <div style={{ maxWidth: '1000px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '3rem', textAlign: 'center' }}>
                    <div>
                        <div style={{ fontSize: '3.5rem', fontWeight: 'bold', color: '#818cf8', marginBottom: '0.5rem' }}>Live</div>
                        <div style={{ fontSize: '1.1rem', color: '#94a3b8' }}>Positions actualisées</div>
                    </div>
                    <div>
                        <div style={{ fontSize: '3.5rem', fontWeight: 'bold', color: '#818cf8', marginBottom: '0.5rem' }}>100%</div>
                        <div style={{ fontSize: '1.1rem', color: '#94a3b8' }}>Connectivité Chauffeurs</div>
                    </div>
                    <div>
                        <div style={{ fontSize: '3.5rem', fontWeight: 'bold', color: '#818cf8', marginBottom: '0.5rem' }}>-40%</div>
                        <div style={{ fontSize: '1.1rem', color: '#94a3b8' }}>Appels de vérification</div>
                    </div>
                </div>
            </section>

            {/* Footer CTA */}
            <section className="saas-hero" style={{ padding: '6rem 5%', textAlign: 'center', backgroundColor: '#ffffff' }}>
                <h2 style={{ fontSize: '2.5rem', marginBottom: '1.5rem', color: '#0f172a' }}>Prenez le contrôle de l'exécution</h2>
                <p style={{ maxWidth: '600px', margin: '0 auto 2.5rem', fontSize: '1.15rem', color: '#475569', lineHeight: '1.6' }}>
                    Assurez un service irréprochable à vos clients en maîtrisant exactement ce qu'il se passe sur le terrain à chaque instant.
                </p>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                    <Link to="/contact" className="saas-btn saas-btn-primary" style={{ padding: '1rem 2.5rem', fontSize: '1.15rem', borderRadius: '8px' }}>
                        Contacter notre équipe <ArrowRight size={20} style={{ marginLeft: '0.5rem' }} />
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default SuiviTempsReel;
